export function GetColorByName(name: string): { background: string; text: string } {
  let hash = 0;
  if (name) {
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
  }

  let background = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    background += value.toString(16).padStart(2, '0');
  }

  if (!name) {
    background = '#cccccc';
  }

  // Parse RGB
  const r = parseInt(background.slice(1, 3), 16) / 255;
  const g = parseInt(background.slice(3, 5), 16) / 255;
  const b = parseInt(background.slice(5, 7), 16) / 255;

  // Convert to HSL
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0,
    s = 0;
  const l = (max + min) / 2;
  const d = max - min;
  if (d !== 0) {
    s = d / (1 - Math.abs(2 * l - 1));
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h = h * 60;
  }

  // Choose text lightness: dark text on light bg => L=15%; light text on dark bg => L=85%
  const yiq = r * 299 + g * 587 + b * 114;
  const textLightness = yiq >= 0.5 ? 15 : 85;
  const text = `hsl(${Math.round(h)}, ${Math.round(
    s * 100
  )}%, ${textLightness}%)`;

  return { background, text };
}
